<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col red">
            <h3><i class="fas fa-dollar-sign"></i>Accounts</h3>
          </div>
          <div class="text-right">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a>
          </div>
      </div>
    </div>
    <div class="card-body bid-detail settingWid" v-if="orgSettings">
      <div class="mb-3">
        <span class="mr-3">TMC : </span>
        <span>{{getAccountName(orgSettings.tmcAccountId)}}</span>
      </div>
      <div class="mb-3">
        <span class="mr-3">BondPoint : </span>
        <span>{{getAccountName(orgSettings.ibpAccountId)}}</span>
      </div>
      <div class="mb-3">
        <span class="mr-3">TradeWeb : </span>
        <span>{{getAccountName(orgSettings.twdAccountId)}}</span>
      </div>  
      <div class="mb-3">
        <span class="mr-3">MarketAxess : </span>
        <span>{{getAccountName(orgSettings.mktxAccountId)}}</span>
      </div>   
      <!-- <div class="bid mb-2"><div>TMC:</div> <span>{{getAccountName(settings.tmcAccountId)}}</span></div>
      <div class="bid mb-2"><div>BondPoint:</div> <span >{{getAccountName(settings.bpAccountId)}}</span></div>
      <div class="bid mb-2"><div>TradeWeb:</div> <span >{{getAccountName(settings.twAccountId)}}</span></div> -->
    </div>
  </div> 
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "accountsWidget",
  data() {
    return {
      orgSettings : null,
      traderSettings : null,
      accountList : [],
      loading : false
    };
  },
  methods: {
     navigateListPage(){
      window.location.href = "/ims/ims-tradingaccounts";
    },
    getAccountName(id){
      //console.log(id);
      return id ? this.accountList.find(x => x.id == id).account : 'N/A';
    },
    getTraderSetting(){
        const auth = {
          headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
          .get(
            config.baseUrlBidSide +
            "/user/offering?cognitoSub="+
            authService.getUser().cognitoSub,
            auth
          )
          .then((result) => {
            this.orgSettings = result.data;
          })
      },
    getBrokerAccountList(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD,MKTX",
            auth
            )
            .then(response => {
              this.accountList = response.data;
              this.getTraderSetting();
              

            })
            .catch(e => {
            console.log(e);
            });
    }
    
  },
  mounted() {
    this.getBrokerAccountList()

  }
};
</script>